import React, { useState, useEffect } from 'react';
import { Loading } from './components/Loading';
import { Main } from './pages/Main';

function App() {
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 2000); // exibe o loading por 5 segundos

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className=''>
      {showLoading ? <Loading /> : (
        <Main />
      )}
    </div>
  );
}

export default App;
